// Generated types for Attribute
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttributeReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** Human-readable label (e.g. 'Maximum Torque', 'IP Rating'). */
  display_label?: string;
  /** Coarse grouping ('mechanical' / 'electrical' / 'environmental' / ...). */
  category?: string | null;
}

export interface AttributeWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** Human-readable label (e.g. 'Maximum Torque', 'IP Rating'). */
  display_label?: string;
  /** Coarse grouping ('mechanical' / 'electrical' / 'environmental' / ...). */
  category?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttributeReadAPISchemaObject = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  display_label: z.string().optional(),
  category: z.string().nullable().optional(),
}).passthrough();
export const AttributeReadAPISchema: z.ZodType<AttributeReadAPI> = AttributeReadAPISchemaObject;

export const AttributeWriteAPISchemaObject = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  display_label: z.string().optional(),
  category: z.string().nullable().optional(),
}).passthrough();
export const AttributeWriteAPISchema: z.ZodType<AttributeWriteAPI> = AttributeWriteAPISchemaObject;
